import React, { useState } from 'react';
import NavMenu from '../../NavMenu';
import Sidebar from "../../sidebar/Sidebar";
import "./AdminLayout.css";

const AdminLayout = ({ children }) => {
    const [isOpen, setIsOpen] = useState(true);

    const toggleSidebar = () => {
        setIsOpen(prevIsOpen => !prevIsOpen);
    };

    return (
        <div className="admin-layout">
            <NavMenu />
            <div className={`container-custom ${isOpen ? '' : ' collapsed'}`}>
            <Sidebar isOpen={isOpen} toggleSidebar={toggleSidebar}/>
                {children}
            </div>
        </div>
    );
};

export default AdminLayout;